import axios from "axios";
import { stringify } from "querystring";
import config from "../config";


const generateAccessToken =async ()=>{

    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get('code');
    if(!code || code === undefined || code?.length === 0){
        window.location.pathname ='/'
    }
    const body ={
        grant_type: "authorization_code",
        code: code,
        client_id: config.CLIENT_ID,
        redirect_uri: config.REDIRECT_URL
    }
    if(code)
    {
        await axios.post(config.TID_OUTH, stringify(body), {
            headers: {
                'Authorization': config.AUTHORIZATION,
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(
            (res) => {
                sessionStorage.setItem('access_token', res.data.access_token)
                window.location.href = window.location.href.split('?')[0];

            }

        )
       
}
    
}

export default generateAccessToken;